import React from "react";
import Theme from "../../theme.module.css";
import Style from "./CaseStudyGridSingle.module.css";


export default function CaseStudyGridSingle({img, title, slug, desc, setModalOpen}) {

    return (
        <div className={Style.cont}>
            <div className={Style.imgCont} style={{ background: `url(${img})` }}></div>
            <div className={Style.textCont}>
                <h2>{title}</h2>
                <p>{desc}</p>
                <a onClick={() => setModalOpen(slug)} className={`${Theme.greenButton} ${Style.learnMoreBtn}`}>See more</a>
            </div>
        </div>
    )
}